/**
 * TEMPORARY: Firebase initialization for migration period
 * @see MIGRATION-REMOVAL.md for removal instructions
 *
 * This file initializes Firebase for the seamless migration from Firebase Auth
 * to Supabase Auth. Once all users have been migrated, this file and all
 * Firebase-related code should be removed.
 */

import type { FirebaseApp } from 'firebase/app';
import { getApp, getApps, initializeApp } from 'firebase/app';
import type { Auth } from 'firebase/auth';
import { getAuth } from 'firebase/auth';

let firebaseApp: FirebaseApp | null = null;
let firebaseAuth: Auth | null = null;

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
	databaseURL: import.meta.env.VITE_FIREBASE_DB_URL,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
};

/**
 * Initialize Firebase app (singleton)
 * TEMPORARY: Remove after migration complete
 */
export const initializeFirebase = (): FirebaseApp => {
	if (!firebaseApp) {
		firebaseApp = !getApps()?.length ? initializeApp(firebaseConfig) : getApp();
	}
	return firebaseApp;
};

/**
 * Get Firebase Auth instance
 * TEMPORARY: Remove after migration complete
 */
export const getFirebaseAuth = (): Auth => {
	if (!firebaseAuth) {
		const app = initializeFirebase();
		firebaseAuth = getAuth(app);
	}
	return firebaseAuth;
};
